const CruisePickupMarker = 'Cruise port: ';

export const emptyTourCruisePickup = {
  lineName: '',
  shipName: '',
  arrival: '',
  departure: '',
};

export const writeTourCruisePickup = (cruise) => {
  const details = [cruise.lineName, cruise.shipName, cruise.arrival, cruise.departure]
    .map((part) => (part || '').trim())
    .join(', ');
  const text = CruisePickupMarker + details;
  return text;
};

export const readTourCruisePickup = (text) => {
  if (!(text || '').startsWith(CruisePickupMarker)) {
    return null;
  }

  const parts = text
    .slice(CruisePickupMarker.length)
    .split(',')
    .map((part) => part.trim());
  if (parts.length !== 4) {
    return null;
  }

  const cruise = {
    lineName: parts[0],
    shipName: parts[1],
    arrival: parts[2],
    departure: parts[3],
  };
  return cruise;
};
